// @ts-nocheck
export * from '../models/AcceptActionRequest';
export * from '../models/AddActionToProxyRequest';
export * from '../models/AirdropAddressResponse';
export * from '../models/AirdropAddressResponseTdhWallet';
export * from '../models/AllowlistNormalizedEntry';
export * from '../models/ApiAddReactionToDropRequest';
export * from '../models/ApiAggregatedActivity';
export * from '../models/ApiAggregatedActivityMemes';
export * from '../models/ApiAggregatedActivityPage';
export * from '../models/ApiArtistNameItem';
export * from '../models/ApiAvailableRatingCredit';
export * from '../models/ApiBlockItem';
export * from '../models/ApiBlocksPage';
export * from '../models/ApiBulkRateRequest';
export * from '../models/ApiBulkRateResponse';
export * from '../models/ApiBulkRateSkippedIdentity';
export * from '../models/ApiBulkRepRequest';
export * from '../models/ApiBulkRepTarget';
export * from '../models/ApiChangeGroupVisibility';
export * from '../models/ApiChangeProfileCicRating';
export * from '../models/ApiChangeProfileRepRating';
export * from '../models/ApiCicContributor';
export * from '../models/ApiCicContributorsPage';
export * from '../models/ApiCicOverview';
export * from '../models/ApiCollectedStats';
export * from '../models/ApiCollectedStatsSeason';
export * from '../models/ApiCommunityMemberMinimal';
export * from '../models/ApiCommunityMemberOverview';
export * from '../models/ApiCommunityMembersPage';
export * from '../models/ApiCommunityMembersSortOption';
export * from '../models/ApiCommunityMetric';
export * from '../models/ApiCommunityMetricSample';
export * from '../models/ApiCommunityMetrics';
export * from '../models/ApiCommunityMetricsSeries';
export * from '../models/ApiCompleteMultipartUploadRequest';
export * from '../models/ApiCompleteMultipartUploadRequestPart';
export * from '../models/ApiCompleteMultipartUploadResponse';
export * from '../models/ApiConsolidatedTdh';
export * from '../models/ApiCreateDropPart';
export * from '../models/ApiCreateDropRequest';
export * from '../models/ApiCreateGroup';
export * from '../models/ApiCreateGroupDescription';
export * from '../models/ApiCreateMediaUploadUrlRequest';
export * from '../models/ApiCreateMediaUrlResponse';
export * from '../models/ApiCreateMentionedWave';
export * from '../models/ApiCreateNewProfileProxy';
export * from '../models/ApiCreateNewProfileProxyAllocateCicAction';
export * from '../models/ApiCreateNewProfileProxyAllocateRepAction';
export * from '../models/ApiCreateNewProfileProxyCreateWaveAction';
export * from '../models/ApiCreateNewProfileProxyCreateWaveParticipationDropAction';
export * from '../models/ApiCreateNewProfileProxyRateWaveDropAction';
export * from '../models/ApiCreateNewProfileProxyReadWaveAction';
export * from '../models/ApiCreateNewWave';
export * from '../models/ApiCreateNewWaveChatConfig';
export * from '../models/ApiCreateNewWaveParticipationConfig';
export * from '../models/ApiCreateNewWaveScope';
export * from '../models/ApiCreateNewWaveVisibilityConfig';
export * from '../models/ApiCreateNewWaveVotingConfig';
export * from '../models/ApiCreateOrUpdateProfileRequest';
export * from '../models/ApiCreateWaveConfig';
export * from '../models/ApiCreateWaveDropRequest';
export * from '../models/ApiCreateWaveOutcome';
export * from '../models/ApiCreateWaveOutcomeDistributionItem';
export * from '../models/ApiDistributionAirdropsCsvUploadRequest';
export * from '../models/ApiDistributionAirdropsUploadResponse';
export * from '../models/ApiDrop';
export * from '../models/ApiDropAndDropVote';
export * from '../models/ApiDropBoost';
export * from '../models/ApiDropBoostsPage';
export * from '../models/ApiDropContextProfileContext';
export * from '../models/ApiDropId';
export * from '../models/ApiDropMedia';
export * from '../models/ApiDropMentionedUser';
export * from '../models/ApiDropMetadata';
export * from '../models/ApiDropMetadataResponse';
export * from '../models/ApiDropNftLink';
export * from '../models/ApiDropPart';
export * from '../models/ApiDropRater';
export * from '../models/ApiDropRatingRequest';
export * from '../models/ApiDropReaction';
export * from '../models/ApiDropReferencedNFT';
export * from '../models/ApiDropResolvedIdentityProfile';
export * from '../models/ApiDropSearchStrategy';
export * from '../models/ApiDropSubscriptionActions';
export * from '../models/ApiDropSubscriptionTargetAction';
export * from '../models/ApiDropTraceItem';
export * from '../models/ApiDropType';
export * from '../models/ApiDropVote';
export * from '../models/ApiDropWinningContext';
export * from '../models/ApiDropWithoutWave';
export * from '../models/ApiDropWithoutWavesPageWithoutCount';
export * from '../models/ApiDropsLeaderboardPage';
export * from '../models/ApiDropsPage';
export * from '../models/ApiFeedItem';
export * from '../models/ApiFeedItemType';
export * from '../models/ApiGroup';
export * from '../models/ApiGroupCicFilter';
export * from '../models/ApiGroupDescription';
export * from '../models/ApiGroupFilterDirection';
export * from '../models/ApiGroupFull';
export * from '../models/ApiGroupLevelFilter';
export * from '../models/ApiGroupOwnsNft';
export * from '../models/ApiGroupRepFilter';
export * from '../models/ApiGroupTdhFilter';
export * from '../models/ApiGroupTdhInclusionStrategy';
export * from '../models/ApiIdentity';
export * from '../models/ApiIdentityActivity';
export * from '../models/ApiIdentityAndSubscriptionActions';
export * from '../models/ApiIdentitySubscriptionActions';
export * from '../models/ApiIdentitySubscriptionTargetAction';
export * from '../models/ApiIdentitySubscriptionTargetType';
export * from '../models/ApiIncomingIdentitySubscriptionsPage';
export * from '../models/ApiIntRange';
export * from '../models/ApiLightDrop';
export * from '../models/ApiLoginRequest';
export * from '../models/ApiLoginResponse';
export * from '../models/ApiMarkDropUnreadResponse';
export * from '../models/ApiMemesMintStat';
export * from '../models/ApiMemesMintStatsPage';
export * from '../models/ApiMemesMintStatsTotals';
export * from '../models/ApiMemesMintStatsYearly';
export * from '../models/ApiMentionedWave';
export * from '../models/ApiMintMetrics';
export * from '../models/ApiMintMetricsPage';
export * from '../models/ApiMintingClaimAction';
export * from '../models/ApiMintingClaimActionTypesResponse';
export * from '../models/ApiMintingClaimActionUpdateRequest';
export * from '../models/ApiMintingClaimActionsResponse';
export * from '../models/ApiMintingClaimsPhaseTotalItem';
export * from '../models/ApiNft';
export * from '../models/ApiNftLinkData';
export * from '../models/ApiNftLinkMediaPreview';
export * from '../models/ApiNftLinkResponse';
export * from '../models/ApiNftMedia';
export * from '../models/ApiNftOwner';
export * from '../models/ApiNftOwnerPage';
export * from '../models/ApiNftsPage';
export * from '../models/ApiNonceResponse';
export * from '../models/ApiNotification';
export * from '../models/ApiNotificationCause';
export * from '../models/ApiNotificationsResponse';
export * from '../models/ApiOutgoingIdentitySubscriptionsPage';
export * from '../models/ApiOwnerBalance';
export * from '../models/ApiOwnerBalanceMemes';
export * from '../models/ApiOwnerBalancePage';
export * from '../models/ApiPageBase';
export * from '../models/ApiPageSortDirection';
export * from '../models/ApiPageWithNextUriBase';
export * from '../models/ApiPageWithoutCount';
export * from '../models/ApiProfileClassification';
export * from '../models/ApiProfileMin';
export * from '../models/ApiProfileMinsPage';
export * from '../models/ApiProfileProxy';
export * from '../models/ApiProfileProxyAction';
export * from '../models/ApiProfileProxyActionType';
export * from '../models/ApiProfileRepCategorySummary';
export * from '../models/ApiPushNotificationDevice';
export * from '../models/ApiPushNotificationSettings';
export * from '../models/ApiPushNotificationSettingsUpdate';
export * from '../models/ApiQuotedDrop';
export * from '../models/ApiQuotedDropResponse';
export * from '../models/ApiRateMatter';
export * from '../models/ApiRatingWithProfileInfoAndLevel';
export * from '../models/ApiRatingWithProfileInfoAndLevelPage';
export * from '../models/ApiRedeemRefreshTokenRequest';
export * from '../models/ApiRedeemRefreshTokenResponse';
export * from '../models/ApiRegisterPushNotificationTokenRequest';
export * from '../models/ApiRepCategoriesPage';
export * from '../models/ApiRepCategory';
export * from '../models/ApiRepContributor';
export * from '../models/ApiRepContributorsPage';
export * from '../models/ApiRepDirection';
export * from '../models/ApiRepOverview';
export * from '../models/ApiRepRating';
export * from '../models/ApiReplyToDrop';
export * from '../models/ApiReplyToDropResponse';
export * from '../models/ApiSeizeSettings';
export * from '../models/ApiSetPinnedDropRequest';
export * from '../models/ApiStartMultipartMediaUploadResponse';
export * from '../models/ApiTargetAndSubscriptionActions';
export * from '../models/ApiTdhEdition';
export * from '../models/ApiTdhEditionsPage';
export * from '../models/ApiTokenTdh';
export * from '../models/ApiTokenTdhRank';
export * from '../models/ApiTransaction';
export * from '../models/ApiTransactionPage';
export * from '../models/ApiUndiscoveredDrop';
export * from '../models/ApiUpcomingMemeSubscriptionStatus';
export * from '../models/ApiUpdateDropRequest';
export * from '../models/ApiUpdateProxyActionRequest';
export * from '../models/ApiUpdateWaveDecisionPause';
export * from '../models/ApiUpdateWaveParticipationConfig';
export * from '../models/ApiUpdateWaveRequest';
export * from '../models/ApiUploadItem';
export * from '../models/ApiUploadPartOfMultipartUploadRequest';
export * from '../models/ApiUploadPartOfMultipartUploadResponse';
export * from '../models/ApiUploadsPage';
export * from '../models/ApiWallet';
export * from '../models/ApiWave';
export * from '../models/ApiWaveChatConfig';
export * from '../models/ApiWaveConfig';
export * from '../models/ApiWaveContributorOverview';
export * from '../models/ApiWaveCreditScope';
export * from '../models/ApiWaveCreditType';
export * from '../models/ApiWaveCurationGroup';
export * from '../models/ApiWaveCurationGroupRequest';
export * from '../models/ApiWaveDecision';
export * from '../models/ApiWaveDecisionAward';
export * from '../models/ApiWaveDecisionPause';
export * from '../models/ApiWaveDecisionWinner';
export * from '../models/ApiWaveDecisionsPage';
export * from '../models/ApiWaveDecisionsStrategy';
export * from '../models/ApiWaveDropsFeed';
export * from '../models/ApiWaveLog';
export * from '../models/ApiWaveMetadataType';
export * from '../models/ApiWaveMetrics';
export * from '../models/ApiWaveMin';
export * from '../models/ApiWaveOutcome';
export * from '../models/ApiWaveOutcomeCredit';
export * from '../models/ApiWaveOutcomeDistributionItem';
export * from '../models/ApiWaveOutcomeDistributionItemsPage';
export * from '../models/ApiWaveOutcomeSubType';
export * from '../models/ApiWaveOutcomeType';
export * from '../models/ApiWaveOutcomesPage';
export * from '../models/ApiWaveParticipationConfig';
export * from '../models/ApiWaveParticipationIdentitySubmissionAllowDuplicates';
export * from '../models/ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted';
export * from '../models/ApiWaveParticipationRequirement';
export * from '../models/ApiWaveParticipationSubmissionStrategy';
export * from '../models/ApiWaveParticipationSubmissionStrategyIdentityConf';
export * from '../models/ApiWaveParticipationSubmissionStrategyType';
export * from '../models/ApiWaveRequiredMetadata';
export * from '../models/ApiWaveScope';
export * from '../models/ApiWaveSelection';
export * from '../models/ApiWaveSelectionDropRequest';
export * from '../models/ApiWaveSelectionRequest';
export * from '../models/ApiWaveSubscriptionActions';
export * from '../models/ApiWaveSubscriptionTargetAction';
export * from '../models/ApiWaveType';
export * from '../models/ApiWaveVisibilityConfig';
export * from '../models/ApiWaveVoter';
export * from '../models/ApiWaveVotersPage';
export * from '../models/ApiWaveVotingConfig';
export * from '../models/ApiWavesOverviewType';
export * from '../models/ApiWavesPinFilter';
export * from '../models/ApiXTdhCollection';
export * from '../models/ApiXTdhCollectionsPage';
export * from '../models/ApiXTdhContribution';
export * from '../models/ApiXTdhContributionsPage';
export * from '../models/ApiXTdhCreateGrant';
export * from '../models/ApiXTdhGlobalStats';
export * from '../models/ApiXTdhGrant';
export * from '../models/ApiXTdhGrantStatus';
export * from '../models/ApiXTdhGrantTargetChain';
export * from '../models/ApiXTdhGrantToken';
export * from '../models/ApiXTdhGrantTokensPage';
export * from '../models/ApiXTdhGrantUpdateRequest';
export * from '../models/ApiXTdhGrantee';
export * from '../models/ApiXTdhGranteesPage';
export * from '../models/ApiXTdhGrantsPage';
export * from '../models/ApiXTdhStats';
export * from '../models/ApiXTdhToken';
export * from '../models/ApiXTdhTokensPage';
export * from '../models/CreateDirectMessageWaveRequest';
export * from '../models/DistributionNormalized';
export * from '../models/DistributionNormalizedPage';
export * from '../models/DistributionOverview';
export * from '../models/DistributionPhasesPage';
export * from '../models/DistributionPhoto';
export * from '../models/DistributionPhotoCompleteRequest';
export * from '../models/DistributionPhotoCompleteRequestPhoto';
export * from '../models/DistributionPhotoCompleteResponse';
export * from '../models/DistributionPhotosPage';
export * from '../models/GetWaveSubscription200Response';
export * from '../models/MintingClaim';
export * from '../models/MintingClaimAnimationDetails';
export * from '../models/MintingClaimAnimationDetailsGlb';
export * from '../models/MintingClaimAnimationDetailsHtml';
export * from '../models/MintingClaimAnimationDetailsVideo';
export * from '../models/MintingClaimAttribute';
export * from '../models/MintingClaimAttributeValue';
export * from '../models/MintingClaimImageDetails';
export * from '../models/MintingClaimUpdateRequest';
export * from '../models/MintingClaimsPageResponse';
export * from '../models/MintingClaimsProofItem';
export * from '../models/MintingClaimsProofsResponse';
export * from '../models/MintingClaimsResponse';
export * from '../models/MintingClaimsRootItem';
export * from '../models/NFTFinalSubscription';
export * from '../models/NFTFinalSubscriptionUpload';
export * from '../models/NFTFinalSubscriptionUploadPage';
export * from '../models/NFTSubscription';
export * from '../models/PhaseAirdrop';
export * from '../models/RedeemedSubscription';
export * from '../models/RedeemedSubscriptionCounts';
export * from '../models/RedeemedSubscriptionCountsPage';
export * from '../models/RedeemedSubscriptionPage';
export * from '../models/SubscribeAllEditionsResponse';
export * from '../models/SubscriptionCountResponse';
export * from '../models/SubscriptionCounts';
export * from '../models/SubscriptionDetails';
export * from '../models/SubscriptionLog';
export * from '../models/SubscriptionLogPage';
export * from '../models/SubscriptionModeResponse';
export * from '../models/SubscriptionResponse';
export * from '../models/SubscriptionTopUp';
export * from '../models/SubscriptionTopUpPage';
export * from '../models/UpdateSubscribeAllEditionsRequest';
export * from '../models/UpdateSubscriptionCountRequest';
export * from '../models/UpdateSubscriptionModeRequest';
export * from '../models/UpdateSubscriptionRequest';

import { AcceptActionRequest, AcceptActionRequestActionEnum   } from '../models/AcceptActionRequest';
import { AddActionToProxyRequest    } from '../models/AddActionToProxyRequest';
import { AirdropAddressResponse } from '../models/AirdropAddressResponse';
import { AirdropAddressResponseTdhWallet } from '../models/AirdropAddressResponseTdhWallet';
import { AllowlistNormalizedEntry } from '../models/AllowlistNormalizedEntry';
import { ApiAddReactionToDropRequest } from '../models/ApiAddReactionToDropRequest';
import { ApiAggregatedActivity } from '../models/ApiAggregatedActivity';
import { ApiAggregatedActivityMemes } from '../models/ApiAggregatedActivityMemes';
import { ApiAggregatedActivityPage } from '../models/ApiAggregatedActivityPage';
import { ApiArtistNameItem } from '../models/ApiArtistNameItem';
import { ApiAvailableRatingCredit } from '../models/ApiAvailableRatingCredit';
import { ApiBlockItem } from '../models/ApiBlockItem';
import { ApiBlocksPage } from '../models/ApiBlocksPage';
import { ApiBulkRateRequest     } from '../models/ApiBulkRateRequest';
import { ApiBulkRateResponse } from '../models/ApiBulkRateResponse';
import { ApiBulkRateSkippedIdentity } from '../models/ApiBulkRateSkippedIdentity';
import { ApiBulkRepRequest } from '../models/ApiBulkRepRequest';
import { ApiBulkRepTarget } from '../models/ApiBulkRepTarget';
import { ApiChangeGroupVisibility } from '../models/ApiChangeGroupVisibility';
import { ApiChangeProfileCicRating } from '../models/ApiChangeProfileCicRating';
import { ApiChangeProfileRepRating } from '../models/ApiChangeProfileRepRating';
import { ApiCicContributor } from '../models/ApiCicContributor';
import { ApiCicContributorsPage } from '../models/ApiCicContributorsPage';
import { ApiCicOverview } from '../models/ApiCicOverview';
import { ApiCollectedStats } from '../models/ApiCollectedStats';
import { ApiCollectedStatsSeason } from '../models/ApiCollectedStatsSeason';
import { ApiCommunityMemberMinimal } from '../models/ApiCommunityMemberMinimal';
import { ApiCommunityMemberOverview } from '../models/ApiCommunityMemberOverview';
import { ApiCommunityMembersPage } from '../models/ApiCommunityMembersPage';
import { ApiCommunityMembersSortOption } from '../models/ApiCommunityMembersSortOption';
import { ApiCommunityMetric } from '../models/ApiCommunityMetric';
import { ApiCommunityMetricSample } from '../models/ApiCommunityMetricSample';
import { ApiCommunityMetrics } from '../models/ApiCommunityMetrics';
import { ApiCommunityMetricsSeries } from '../models/ApiCommunityMetricsSeries';
import { ApiCompleteMultipartUploadRequest } from '../models/ApiCompleteMultipartUploadRequest';
import { ApiCompleteMultipartUploadRequestPart } from '../models/ApiCompleteMultipartUploadRequestPart';
import { ApiCompleteMultipartUploadResponse } from '../models/ApiCompleteMultipartUploadResponse';
import { ApiConsolidatedTdh } from '../models/ApiConsolidatedTdh';
import { ApiCreateDropPart } from '../models/ApiCreateDropPart';
import { ApiCreateDropRequest              } from '../models/ApiCreateDropRequest';
import { ApiCreateGroup } from '../models/ApiCreateGroup';
import { ApiCreateGroupDescription } from '../models/ApiCreateGroupDescription';
import { ApiCreateMediaUploadUrlRequest } from '../models/ApiCreateMediaUploadUrlRequest';
import { ApiCreateMediaUrlResponse } from '../models/ApiCreateMediaUrlResponse';
import { ApiCreateMentionedWave } from '../models/ApiCreateMentionedWave';
import { ApiCreateNewProfileProxy } from '../models/ApiCreateNewProfileProxy';
import { ApiCreateNewProfileProxyAllocateCicAction    } from '../models/ApiCreateNewProfileProxyAllocateCicAction';
import { ApiCreateNewProfileProxyAllocateRepAction    } from '../models/ApiCreateNewProfileProxyAllocateRepAction';
import { ApiCreateNewProfileProxyCreateWaveAction   } from '../models/ApiCreateNewProfileProxyCreateWaveAction';
import { ApiCreateNewProfileProxyCreateWaveParticipationDropAction   } from '../models/ApiCreateNewProfileProxyCreateWaveParticipationDropAction';
import { ApiCreateNewProfileProxyRateWaveDropAction   } from '../models/ApiCreateNewProfileProxyRateWaveDropAction';
import { ApiCreateNewProfileProxyReadWaveAction   } from '../models/ApiCreateNewProfileProxyReadWaveAction';
import { ApiCreateNewWave } from '../models/ApiCreateNewWave';
import { ApiCreateNewWaveChatConfig } from '../models/ApiCreateNewWaveChatConfig';
import { ApiCreateNewWaveParticipationConfig } from '../models/ApiCreateNewWaveParticipationConfig';
import { ApiCreateNewWaveScope } from '../models/ApiCreateNewWaveScope';
import { ApiCreateNewWaveVisibilityConfig } from '../models/ApiCreateNewWaveVisibilityConfig';
import { ApiCreateNewWaveVotingConfig         } from '../models/ApiCreateNewWaveVotingConfig';
import { ApiCreateOrUpdateProfileRequest        } from '../models/ApiCreateOrUpdateProfileRequest';
import { ApiCreateWaveConfig        } from '../models/ApiCreateWaveConfig';
import { ApiCreateWaveDropRequest } from '../models/ApiCreateWaveDropRequest';
import { ApiCreateWaveOutcome        } from '../models/ApiCreateWaveOutcome';
import { ApiCreateWaveOutcomeDistributionItem } from '../models/ApiCreateWaveOutcomeDistributionItem';
import { ApiDistributionAirdropsCsvUploadRequest } from '../models/ApiDistributionAirdropsCsvUploadRequest';
import { ApiDistributionAirdropsUploadResponse } from '../models/ApiDistributionAirdropsUploadResponse';
import { ApiDrop                               } from '../models/ApiDrop';
import { ApiDropAndDropVote } from '../models/ApiDropAndDropVote';
import { ApiDropBoost } from '../models/ApiDropBoost';
import { ApiDropBoostsPage } from '../models/ApiDropBoostsPage';
import { ApiDropContextProfileContext } from '../models/ApiDropContextProfileContext';
import { ApiDropId } from '../models/ApiDropId';
import { ApiDropMedia } from '../models/ApiDropMedia';
import { ApiDropMentionedUser } from '../models/ApiDropMentionedUser';
import { ApiDropMetadata } from '../models/ApiDropMetadata';
import { ApiDropMetadataResponse } from '../models/ApiDropMetadataResponse';
import { ApiDropNftLink } from '../models/ApiDropNftLink';
import { ApiDropPart } from '../models/ApiDropPart';
import { ApiDropRater } from '../models/ApiDropRater';
import { ApiDropRatingRequest } from '../models/ApiDropRatingRequest';
import { ApiDropReaction } from '../models/ApiDropReaction';
import { ApiDropReferencedNFT } from '../models/ApiDropReferencedNFT';
import { ApiDropResolvedIdentityProfile } from '../models/ApiDropResolvedIdentityProfile';
import { ApiDropSearchStrategy } from '../models/ApiDropSearchStrategy';
import { ApiDropSubscriptionActions } from '../models/ApiDropSubscriptionActions';
import { ApiDropSubscriptionTargetAction } from '../models/ApiDropSubscriptionTargetAction';
import { ApiDropTraceItem } from '../models/ApiDropTraceItem';
import { ApiDropType } from '../models/ApiDropType';
import { ApiDropVote } from '../models/ApiDropVote';
import { ApiDropWinningContext } from '../models/ApiDropWinningContext';
import { ApiDropWithoutWave                              } from '../models/ApiDropWithoutWave';
import { ApiDropWithoutWavesPageWithoutCount } from '../models/ApiDropWithoutWavesPageWithoutCount';
import { ApiDropsLeaderboardPage } from '../models/ApiDropsLeaderboardPage';
import { ApiDropsPage } from '../models/ApiDropsPage';
import { ApiFeedItem    } from '../models/ApiFeedItem';
import { ApiFeedItemType } from '../models/ApiFeedItemType';
import { ApiGroup } from '../models/ApiGroup';
import { ApiGroupCicFilter     } from '../models/ApiGroupCicFilter';
import { ApiGroupDescription } from '../models/ApiGroupDescription';
import { ApiGroupFilterDirection } from '../models/ApiGroupFilterDirection';
import { ApiGroupFull } from '../models/ApiGroupFull';
import { ApiGroupLevelFilter } from '../models/ApiGroupLevelFilter';
import { ApiGroupOwnsNft, ApiGroupOwnsNftNameEnum    } from '../models/ApiGroupOwnsNft';
import { ApiGroupRepFilter      } from '../models/ApiGroupRepFilter';
import { ApiGroupTdhFilter    } from '../models/ApiGroupTdhFilter';
import { ApiGroupTdhInclusionStrategy } from '../models/ApiGroupTdhInclusionStrategy';
import { ApiIdentity                         } from '../models/ApiIdentity';
import { ApiIdentityActivity } from '../models/ApiIdentityActivity';
import { ApiIdentityAndSubscriptionActions } from '../models/ApiIdentityAndSubscriptionActions';
import { ApiIdentitySubscriptionActions } from '../models/ApiIdentitySubscriptionActions';
import { ApiIdentitySubscriptionTargetAction } from '../models/ApiIdentitySubscriptionTargetAction';
import { ApiIdentitySubscriptionTargetType } from '../models/ApiIdentitySubscriptionTargetType';
import { ApiIncomingIdentitySubscriptionsPage } from '../models/ApiIncomingIdentitySubscriptionsPage';
import { ApiIntRange } from '../models/ApiIntRange';
import { ApiLightDrop         } from '../models/ApiLightDrop';
import { ApiLoginRequest } from '../models/ApiLoginRequest';
import { ApiLoginResponse } from '../models/ApiLoginResponse';
import { ApiMarkDropUnreadResponse } from '../models/ApiMarkDropUnreadResponse';
import { ApiMemesMintStat } from '../models/ApiMemesMintStat';
import { ApiMemesMintStatsPage } from '../models/ApiMemesMintStatsPage';
import { ApiMemesMintStatsTotals } from '../models/ApiMemesMintStatsTotals';
import { ApiMemesMintStatsYearly } from '../models/ApiMemesMintStatsYearly';
import { ApiMentionedWave } from '../models/ApiMentionedWave';
import { ApiMintMetrics } from '../models/ApiMintMetrics';
import { ApiMintMetricsPage } from '../models/ApiMintMetricsPage';
import { ApiMintingClaimAction } from '../models/ApiMintingClaimAction';
import { ApiMintingClaimActionTypesResponse } from '../models/ApiMintingClaimActionTypesResponse';
import { ApiMintingClaimActionUpdateRequest } from '../models/ApiMintingClaimActionUpdateRequest';
import { ApiMintingClaimActionsResponse } from '../models/ApiMintingClaimActionsResponse';
import { ApiMintingClaimsPhaseTotalItem } from '../models/ApiMintingClaimsPhaseTotalItem';
import { ApiNft      , ApiNftTokenTypeEnum                               } from '../models/ApiNft';
import { ApiNftLinkData } from '../models/ApiNftLinkData';
import { ApiNftLinkMediaPreview, ApiNftLinkMediaPreviewStatusEnum          } from '../models/ApiNftLinkMediaPreview';
import { ApiNftLinkResponse } from '../models/ApiNftLinkResponse';
import { ApiNftMedia } from '../models/ApiNftMedia';
import { ApiNftOwner } from '../models/ApiNftOwner';
import { ApiNftOwnerPage } from '../models/ApiNftOwnerPage';
import { ApiNftsPage } from '../models/ApiNftsPage';
import { ApiNonceResponse } from '../models/ApiNonceResponse';
import { ApiNotification        } from '../models/ApiNotification';
import { ApiNotificationCause } from '../models/ApiNotificationCause';
import { ApiNotificationsResponse } from '../models/ApiNotificationsResponse';
import { ApiOutgoingIdentitySubscriptionsPage } from '../models/ApiOutgoingIdentitySubscriptionsPage';
import { ApiOwnerBalance } from '../models/ApiOwnerBalance';
import { ApiOwnerBalanceMemes } from '../models/ApiOwnerBalanceMemes';
import { ApiOwnerBalancePage } from '../models/ApiOwnerBalancePage';
import { ApiPageBase } from '../models/ApiPageBase';
import { ApiPageSortDirection } from '../models/ApiPageSortDirection';
import { ApiPageWithNextUriBase } from '../models/ApiPageWithNextUriBase';
import { ApiPageWithoutCount } from '../models/ApiPageWithoutCount';
import { ApiProfileClassification } from '../models/ApiProfileClassification';
import { ApiProfileMin } from '../models/ApiProfileMin';
import { ApiProfileMinsPage } from '../models/ApiProfileMinsPage';
import { ApiProfileProxy } from '../models/ApiProfileProxy';
import { ApiProfileProxyAction             } from '../models/ApiProfileProxyAction';
import { ApiProfileProxyActionType } from '../models/ApiProfileProxyActionType';
import { ApiProfileRepCategorySummary } from '../models/ApiProfileRepCategorySummary';
import { ApiPushNotificationDevice } from '../models/ApiPushNotificationDevice';
import { ApiPushNotificationSettings } from '../models/ApiPushNotificationSettings';
import { ApiPushNotificationSettingsUpdate } from '../models/ApiPushNotificationSettingsUpdate';
import { ApiQuotedDrop } from '../models/ApiQuotedDrop';
import { ApiQuotedDropResponse } from '../models/ApiQuotedDropResponse';
import { ApiRateMatter } from '../models/ApiRateMatter';
import { ApiRatingWithProfileInfoAndLevel } from '../models/ApiRatingWithProfileInfoAndLevel';
import { ApiRatingWithProfileInfoAndLevelPage } from '../models/ApiRatingWithProfileInfoAndLevelPage';
import { ApiRedeemRefreshTokenRequest } from '../models/ApiRedeemRefreshTokenRequest';
import { ApiRedeemRefreshTokenResponse } from '../models/ApiRedeemRefreshTokenResponse';
import { ApiRegisterPushNotificationTokenRequest } from '../models/ApiRegisterPushNotificationTokenRequest';
import { ApiRepCategoriesPage } from '../models/ApiRepCategoriesPage';
import { ApiRepCategory } from '../models/ApiRepCategory';
import { ApiRepContributor } from '../models/ApiRepContributor';
import { ApiRepContributorsPage } from '../models/ApiRepContributorsPage';
import { ApiRepDirection } from '../models/ApiRepDirection';
import { ApiRepOverview } from '../models/ApiRepOverview';
import { ApiRepRating } from '../models/ApiRepRating';
import { ApiReplyToDrop } from '../models/ApiReplyToDrop';
import { ApiReplyToDropResponse } from '../models/ApiReplyToDropResponse';
import { ApiSeizeSettings } from '../models/ApiSeizeSettings';
import { ApiSetPinnedDropRequest } from '../models/ApiSetPinnedDropRequest';
import { ApiStartMultipartMediaUploadResponse } from '../models/ApiStartMultipartMediaUploadResponse';
import { ApiTargetAndSubscriptionActions } from '../models/ApiTargetAndSubscriptionActions';
import { ApiTdhEdition } from '../models/ApiTdhEdition';
import { ApiTdhEditionsPage } from '../models/ApiTdhEditionsPage';
import { ApiTokenTdh } from '../models/ApiTokenTdh';
import { ApiTokenTdhRank } from '../models/ApiTokenTdhRank';
import { ApiTransaction } from '../models/ApiTransaction';
import { ApiTransactionPage } from '../models/ApiTransactionPage';
import { ApiUndiscoveredDrop } from '../models/ApiUndiscoveredDrop';
import { ApiUpcomingMemeSubscriptionStatus   , ApiUpcomingMemeSubscriptionStatusSourceEnum   } from '../models/ApiUpcomingMemeSubscriptionStatus';
import { ApiUpdateDropRequest } from '../models/ApiUpdateDropRequest';
import { ApiUpdateProxyActionRequest } from '../models/ApiUpdateProxyActionRequest';
import { ApiUpdateWaveDecisionPause } from '../models/ApiUpdateWaveDecisionPause';
import { ApiUpdateWaveParticipationConfig } from '../models/ApiUpdateWaveParticipationConfig';
import { ApiUpdateWaveRequest } from '../models/ApiUpdateWaveRequest';
import { ApiUploadItem } from '../models/ApiUploadItem';
import { ApiUploadPartOfMultipartUploadRequest } from '../models/ApiUploadPartOfMultipartUploadRequest';
import { ApiUploadPartOfMultipartUploadResponse } from '../models/ApiUploadPartOfMultipartUploadResponse';
import { ApiUploadsPage } from '../models/ApiUploadsPage';
import { ApiWallet } from '../models/ApiWallet';
import { ApiWave } from '../models/ApiWave';
import { ApiWaveChatConfig } from '../models/ApiWaveChatConfig';
import { ApiWaveConfig          } from '../models/ApiWaveConfig';
import { ApiWaveContributorOverview } from '../models/ApiWaveContributorOverview';
import { ApiWaveCreditScope } from '../models/ApiWaveCreditScope';
import { ApiWaveCreditType } from '../models/ApiWaveCreditType';
import { ApiWaveCurationGroup } from '../models/ApiWaveCurationGroup';
import { ApiWaveCurationGroupRequest } from '../models/ApiWaveCurationGroupRequest';
import { ApiWaveDecision } from '../models/ApiWaveDecision';
import { ApiWaveDecisionAward       } from '../models/ApiWaveDecisionAward';
import { ApiWaveDecisionPause } from '../models/ApiWaveDecisionPause';
import { ApiWaveDecisionWinner } from '../models/ApiWaveDecisionWinner';
import { ApiWaveDecisionsPage } from '../models/ApiWaveDecisionsPage';
import { ApiWaveDecisionsStrategy } from '../models/ApiWaveDecisionsStrategy';
import { ApiWaveDropsFeed } from '../models/ApiWaveDropsFeed';
import { ApiWaveLog } from '../models/ApiWaveLog';
import { ApiWaveMetadataType } from '../models/ApiWaveMetadataType';
import { ApiWaveMetrics } from '../models/ApiWaveMetrics';
import { ApiWaveMin                       } from '../models/ApiWaveMin';
import { ApiWaveOutcome        } from '../models/ApiWaveOutcome';
import { ApiWaveOutcomeCredit } from '../models/ApiWaveOutcomeCredit';
import { ApiWaveOutcomeDistributionItem } from '../models/ApiWaveOutcomeDistributionItem';
import { ApiWaveOutcomeDistributionItemsPage } from '../models/ApiWaveOutcomeDistributionItemsPage';
import { ApiWaveOutcomeSubType } from '../models/ApiWaveOutcomeSubType';
import { ApiWaveOutcomeType } from '../models/ApiWaveOutcomeType';
import { ApiWaveOutcomesPage } from '../models/ApiWaveOutcomesPage';
import { ApiWaveParticipationConfig } from '../models/ApiWaveParticipationConfig';
import { ApiWaveParticipationIdentitySubmissionAllowDuplicates } from '../models/ApiWaveParticipationIdentitySubmissionAllowDuplicates';
import { ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted } from '../models/ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted';
import { ApiWaveParticipationRequirement } from '../models/ApiWaveParticipationRequirement';
import { ApiWaveParticipationSubmissionStrategy   } from '../models/ApiWaveParticipationSubmissionStrategy';
import { ApiWaveParticipationSubmissionStrategyIdentityConf   } from '../models/ApiWaveParticipationSubmissionStrategyIdentityConf';
import { ApiWaveParticipationSubmissionStrategyType } from '../models/ApiWaveParticipationSubmissionStrategyType';
import { ApiWaveRequiredMetadata   } from '../models/ApiWaveRequiredMetadata';
import { ApiWaveScope } from '../models/ApiWaveScope';
import { ApiWaveSelection } from '../models/ApiWaveSelection';
import { ApiWaveSelectionDropRequest } from '../models/ApiWaveSelectionDropRequest';
import { ApiWaveSelectionRequest } from '../models/ApiWaveSelectionRequest';
import { ApiWaveSubscriptionActions } from '../models/ApiWaveSubscriptionActions';
import { ApiWaveSubscriptionTargetAction } from '../models/ApiWaveSubscriptionTargetAction';
import { ApiWaveType } from '../models/ApiWaveType';
import { ApiWaveVisibilityConfig } from '../models/ApiWaveVisibilityConfig';
import { ApiWaveVoter } from '../models/ApiWaveVoter';
import { ApiWaveVotersPage } from '../models/ApiWaveVotersPage';
import { ApiWaveVotingConfig         } from '../models/ApiWaveVotingConfig';
import { ApiWavesOverviewType } from '../models/ApiWavesOverviewType';
import { ApiWavesPinFilter } from '../models/ApiWavesPinFilter';
import { ApiXTdhCollection } from '../models/ApiXTdhCollection';
import { ApiXTdhCollectionsPage } from '../models/ApiXTdhCollectionsPage';
import { ApiXTdhContribution } from '../models/ApiXTdhContribution';
import { ApiXTdhContributionsPage } from '../models/ApiXTdhContributionsPage';
import { ApiXTdhCreateGrant       } from '../models/ApiXTdhCreateGrant';
import { ApiXTdhGlobalStats } from '../models/ApiXTdhGlobalStats';
import { ApiXTdhGrant                } from '../models/ApiXTdhGrant';
import { ApiXTdhGrantStatus } from '../models/ApiXTdhGrantStatus';
import { ApiXTdhGrantTargetChain } from '../models/ApiXTdhGrantTargetChain';
import { ApiXTdhGrantToken } from '../models/ApiXTdhGrantToken';
import { ApiXTdhGrantTokensPage } from '../models/ApiXTdhGrantTokensPage';
import { ApiXTdhGrantUpdateRequest } from '../models/ApiXTdhGrantUpdateRequest';
import { ApiXTdhGrantee } from '../models/ApiXTdhGrantee';
import { ApiXTdhGranteesPage } from '../models/ApiXTdhGranteesPage';
import { ApiXTdhGrantsPage } from '../models/ApiXTdhGrantsPage';
import { ApiXTdhStats } from '../models/ApiXTdhStats';
import { ApiXTdhToken } from '../models/ApiXTdhToken';
import { ApiXTdhTokensPage } from '../models/ApiXTdhTokensPage';
import { CreateDirectMessageWaveRequest } from '../models/CreateDirectMessageWaveRequest';
import { DistributionNormalized } from '../models/DistributionNormalized';
import { DistributionNormalizedPage } from '../models/DistributionNormalizedPage';
import { DistributionOverview } from '../models/DistributionOverview';
import { DistributionPhasesPage } from '../models/DistributionPhasesPage';
import { DistributionPhoto } from '../models/DistributionPhoto';
import { DistributionPhotoCompleteRequest } from '../models/DistributionPhotoCompleteRequest';
import { DistributionPhotoCompleteRequestPhoto } from '../models/DistributionPhotoCompleteRequestPhoto';
import { DistributionPhotoCompleteResponse } from '../models/DistributionPhotoCompleteResponse';
import { DistributionPhotosPage } from '../models/DistributionPhotosPage';
import { GetWaveSubscription200Response } from '../models/GetWaveSubscription200Response';
import { MintingClaim } from '../models/MintingClaim';
import { MintingClaimAnimationDetailsClass } from '../models/MintingClaimAnimationDetails';
import { MintingClaimAnimationDetailsGlb , MintingClaimAnimationDetailsGlbFormatEnum    } from '../models/MintingClaimAnimationDetailsGlb';
import { MintingClaimAnimationDetailsHtml, MintingClaimAnimationDetailsHtmlFormatEnum   } from '../models/MintingClaimAnimationDetailsHtml';
import { MintingClaimAnimationDetailsVideo } from '../models/MintingClaimAnimationDetailsVideo';
import { MintingClaimAttribute } from '../models/MintingClaimAttribute';
import { MintingClaimAttributeValueClass } from '../models/MintingClaimAttributeValue';
import { MintingClaimImageDetails } from '../models/MintingClaimImageDetails';
import { MintingClaimUpdateRequest } from '../models/MintingClaimUpdateRequest';
import { MintingClaimsPageResponse } from '../models/MintingClaimsPageResponse';
import { MintingClaimsProofItem } from '../models/MintingClaimsProofItem';
import { MintingClaimsProofsResponse } from '../models/MintingClaimsProofsResponse';
import { MintingClaimsResponse } from '../models/MintingClaimsResponse';
import { MintingClaimsRootItem } from '../models/MintingClaimsRootItem';
import { NFTFinalSubscription } from '../models/NFTFinalSubscription';
import { NFTFinalSubscriptionUpload } from '../models/NFTFinalSubscriptionUpload';
import { NFTFinalSubscriptionUploadPage } from '../models/NFTFinalSubscriptionUploadPage';
import { NFTSubscription } from '../models/NFTSubscription';
import { PhaseAirdrop } from '../models/PhaseAirdrop';
import { RedeemedSubscription } from '../models/RedeemedSubscription';
import { RedeemedSubscriptionCounts } from '../models/RedeemedSubscriptionCounts';
import { RedeemedSubscriptionCountsPage } from '../models/RedeemedSubscriptionCountsPage';
import { RedeemedSubscriptionPage } from '../models/RedeemedSubscriptionPage';
import { SubscribeAllEditionsResponse } from '../models/SubscribeAllEditionsResponse';
import { SubscriptionCountResponse } from '../models/SubscriptionCountResponse';
import { SubscriptionCounts } from '../models/SubscriptionCounts';
import { SubscriptionDetails } from '../models/SubscriptionDetails';
import { SubscriptionLog } from '../models/SubscriptionLog';
import { SubscriptionLogPage } from '../models/SubscriptionLogPage';
import { SubscriptionModeResponse } from '../models/SubscriptionModeResponse';
import { SubscriptionResponse } from '../models/SubscriptionResponse';
import { SubscriptionTopUp } from '../models/SubscriptionTopUp';
import { SubscriptionTopUpPage } from '../models/SubscriptionTopUpPage';
import { UpdateSubscribeAllEditionsRequest } from '../models/UpdateSubscribeAllEditionsRequest';
import { UpdateSubscriptionCountRequest } from '../models/UpdateSubscriptionCountRequest';
import { UpdateSubscriptionModeRequest } from '../models/UpdateSubscriptionModeRequest';
import { UpdateSubscriptionRequest } from '../models/UpdateSubscriptionRequest';

/* tslint:disable:no-unused-variable */
let primitives = [
                    "string",
                    "boolean",
                    "double",
                    "integer",
                    "long",
                    "float",
                    "number",
                    "any"
                 ];

let enumsMap: Set<string> = new Set<string>([
    "AcceptActionRequestActionEnum",
    "ApiCommunityMembersSortOption",
    "ApiDropSearchStrategy",
    "ApiDropSubscriptionTargetAction",
    "ApiDropType",
    "ApiFeedItemType",
    "ApiGroupFilterDirection",
    "ApiGroupOwnsNftNameEnum",
    "ApiGroupTdhInclusionStrategy",
    "ApiIdentitySubscriptionTargetAction",
    "ApiIdentitySubscriptionTargetType",
    "ApiNftTokenTypeEnum",
    "ApiNftLinkMediaPreviewStatusEnum",
    "ApiNotificationCause",
    "ApiPageSortDirection",
    "ApiProfileClassification",
    "ApiProfileProxyActionType",
    "ApiRateMatter",
    "ApiRepDirection",
    "ApiUpcomingMemeSubscriptionStatusSourceEnum",
    "ApiWaveCreditScope",
    "ApiWaveCreditType",
    "ApiWaveMetadataType",
    "ApiWaveOutcomeCredit",
    "ApiWaveOutcomeSubType",
    "ApiWaveOutcomeType",
    "ApiWaveParticipationIdentitySubmissionAllowDuplicates",
    "ApiWaveParticipationIdentitySubmissionWhoCanBeSubmitted",
    "ApiWaveParticipationRequirement",
    "ApiWaveParticipationSubmissionStrategyType",
    "ApiWaveSubscriptionTargetAction",
    "ApiWaveType",
    "ApiWavesOverviewType",
    "ApiWavesPinFilter",
    "ApiXTdhGrantStatus",
    "ApiXTdhGrantTargetChain",
    "MintingClaimAnimationDetailsFormatEnum",
    "MintingClaimAnimationDetailsGlbFormatEnum",
    "MintingClaimAnimationDetailsHtmlFormatEnum",
]);

let typeMap: {[index: string]: any} = {
    "AcceptActionRequest": AcceptActionRequest,
    "AddActionToProxyRequest": AddActionToProxyRequest,
    "AirdropAddressResponse": AirdropAddressResponse,
    "AirdropAddressResponseTdhWallet": AirdropAddressResponseTdhWallet,
    "AllowlistNormalizedEntry": AllowlistNormalizedEntry,
    "ApiAddReactionToDropRequest": ApiAddReactionToDropRequest,
    "ApiAggregatedActivity": ApiAggregatedActivity,
    "ApiAggregatedActivityMemes": ApiAggregatedActivityMemes,
    "ApiAggregatedActivityPage": ApiAggregatedActivityPage,
    "ApiArtistNameItem": ApiArtistNameItem,
    "ApiAvailableRatingCredit": ApiAvailableRatingCredit,
    "ApiBlockItem": ApiBlockItem,
    "ApiBlocksPage": ApiBlocksPage,
    "ApiBulkRateRequest": ApiBulkRateRequest,
    "ApiBulkRateResponse": ApiBulkRateResponse,
    "ApiBulkRateSkippedIdentity": ApiBulkRateSkippedIdentity,
    "ApiBulkRepRequest": ApiBulkRepRequest,
    "ApiBulkRepTarget": ApiBulkRepTarget,
    "ApiChangeGroupVisibility": ApiChangeGroupVisibility,
    "ApiChangeProfileCicRating": ApiChangeProfileCicRating,
    "ApiChangeProfileRepRating": ApiChangeProfileRepRating,
    "ApiCicContributor": ApiCicContributor,
    "ApiCicContributorsPage": ApiCicContributorsPage,
    "ApiCicOverview": ApiCicOverview,
    "ApiCollectedStats": ApiCollectedStats,
    "ApiCollectedStatsSeason": ApiCollectedStatsSeason,
    "ApiCommunityMemberMinimal": ApiCommunityMemberMinimal,
    "ApiCommunityMemberOverview": ApiCommunityMemberOverview,
    "ApiCommunityMembersPage": ApiCommunityMembersPage,
    "ApiCommunityMetric": ApiCommunityMetric,
    "ApiCommunityMetricSample": ApiCommunityMetricSample,
    "ApiCommunityMetrics": ApiCommunityMetrics,
    "ApiCommunityMetricsSeries": ApiCommunityMetricsSeries,
    "ApiCompleteMultipartUploadRequest": ApiCompleteMultipartUploadRequest,
    "ApiCompleteMultipartUploadRequestPart": ApiCompleteMultipartUploadRequestPart,
    "ApiCompleteMultipartUploadResponse": ApiCompleteMultipartUploadResponse,
    "ApiConsolidatedTdh": ApiConsolidatedTdh,
    "ApiCreateDropPart": ApiCreateDropPart,
    "ApiCreateDropRequest": ApiCreateDropRequest,
    "ApiCreateGroup": ApiCreateGroup,
    "ApiCreateGroupDescription": ApiCreateGroupDescription,
    "ApiCreateMediaUploadUrlRequest": ApiCreateMediaUploadUrlRequest,
    "ApiCreateMediaUrlResponse": ApiCreateMediaUrlResponse,
    "ApiCreateMentionedWave": ApiCreateMentionedWave,
    "ApiCreateNewProfileProxy": ApiCreateNewProfileProxy,
    "ApiCreateNewProfileProxyAllocateCicAction": ApiCreateNewProfileProxyAllocateCicAction,
    "ApiCreateNewProfileProxyAllocateRepAction": ApiCreateNewProfileProxyAllocateRepAction,
    "ApiCreateNewProfileProxyCreateWaveAction": ApiCreateNewProfileProxyCreateWaveAction,
    "ApiCreateNewProfileProxyCreateWaveParticipationDropAction": ApiCreateNewProfileProxyCreateWaveParticipationDropAction,
    "ApiCreateNewProfileProxyRateWaveDropAction": ApiCreateNewProfileProxyRateWaveDropAction,
    "ApiCreateNewProfileProxyReadWaveAction": ApiCreateNewProfileProxyReadWaveAction,
    "ApiCreateNewWave": ApiCreateNewWave,
    "ApiCreateNewWaveChatConfig": ApiCreateNewWaveChatConfig,
    "ApiCreateNewWaveParticipationConfig": ApiCreateNewWaveParticipationConfig,
    "ApiCreateNewWaveScope": ApiCreateNewWaveScope,
    "ApiCreateNewWaveVisibilityConfig": ApiCreateNewWaveVisibilityConfig,
    "ApiCreateNewWaveVotingConfig": ApiCreateNewWaveVotingConfig,
    "ApiCreateOrUpdateProfileRequest": ApiCreateOrUpdateProfileRequest,
    "ApiCreateWaveConfig": ApiCreateWaveConfig,
    "ApiCreateWaveDropRequest": ApiCreateWaveDropRequest,
    "ApiCreateWaveOutcome": ApiCreateWaveOutcome,
    "ApiCreateWaveOutcomeDistributionItem": ApiCreateWaveOutcomeDistributionItem,
    "ApiDistributionAirdropsCsvUploadRequest": ApiDistributionAirdropsCsvUploadRequest,
    "ApiDistributionAirdropsUploadResponse": ApiDistributionAirdropsUploadResponse,
    "ApiDrop": ApiDrop,
    "ApiDropAndDropVote": ApiDropAndDropVote,
    "ApiDropBoost": ApiDropBoost,
    "ApiDropBoostsPage": ApiDropBoostsPage,
    "ApiDropContextProfileContext": ApiDropContextProfileContext,
    "ApiDropId": ApiDropId,
    "ApiDropMedia": ApiDropMedia,
    "ApiDropMentionedUser": ApiDropMentionedUser,
    "ApiDropMetadata": ApiDropMetadata,
    "ApiDropMetadataResponse": ApiDropMetadataResponse,
    "ApiDropNftLink": ApiDropNftLink,
    "ApiDropPart": ApiDropPart,
    "ApiDropRater": ApiDropRater,
    "ApiDropRatingRequest": ApiDropRatingRequest,
    "ApiDropReaction": ApiDropReaction,
    "ApiDropReferencedNFT": ApiDropReferencedNFT,
    "ApiDropResolvedIdentityProfile": ApiDropResolvedIdentityProfile,
    "ApiDropSubscriptionActions": ApiDropSubscriptionActions,
    "ApiDropTraceItem": ApiDropTraceItem,
    "ApiDropVote": ApiDropVote,
    "ApiDropWinningContext": ApiDropWinningContext,
    "ApiDropWithoutWave": ApiDropWithoutWave,
    "ApiDropWithoutWavesPageWithoutCount": ApiDropWithoutWavesPageWithoutCount,
    "ApiDropsLeaderboardPage": ApiDropsLeaderboardPage,
    "ApiDropsPage": ApiDropsPage,
    "ApiFeedItem": ApiFeedItem,
    "ApiGroup": ApiGroup,
    "ApiGroupCicFilter": ApiGroupCicFilter,
    "ApiGroupDescription": ApiGroupDescription,
    "ApiGroupFull": ApiGroupFull,
    "ApiGroupLevelFilter": ApiGroupLevelFilter,
    "ApiGroupOwnsNft": ApiGroupOwnsNft,
    "ApiGroupRepFilter": ApiGroupRepFilter,
    "ApiGroupTdhFilter": ApiGroupTdhFilter,
    "ApiIdentity": ApiIdentity,
    "ApiIdentityActivity": ApiIdentityActivity,
    "ApiIdentityAndSubscriptionActions": ApiIdentityAndSubscriptionActions,
    "ApiIdentitySubscriptionActions": ApiIdentitySubscriptionActions,
    "ApiIncomingIdentitySubscriptionsPage": ApiIncomingIdentitySubscriptionsPage,
    "ApiIntRange": ApiIntRange,
    "ApiLightDrop": ApiLightDrop,
    "ApiLoginRequest": ApiLoginRequest,
    "ApiLoginResponse": ApiLoginResponse,
    "ApiMarkDropUnreadResponse": ApiMarkDropUnreadResponse,
    "ApiMemesMintStat": ApiMemesMintStat,
    "ApiMemesMintStatsPage": ApiMemesMintStatsPage,
    "ApiMemesMintStatsTotals": ApiMemesMintStatsTotals,
    "ApiMemesMintStatsYearly": ApiMemesMintStatsYearly,
    "ApiMentionedWave": ApiMentionedWave,
    "ApiMintMetrics": ApiMintMetrics,
    "ApiMintMetricsPage": ApiMintMetricsPage,
    "ApiMintingClaimAction": ApiMintingClaimAction,
    "ApiMintingClaimActionTypesResponse": ApiMintingClaimActionTypesResponse,
    "ApiMintingClaimActionUpdateRequest": ApiMintingClaimActionUpdateRequest,
    "ApiMintingClaimActionsResponse": ApiMintingClaimActionsResponse,
    "ApiMintingClaimsPhaseTotalItem": ApiMintingClaimsPhaseTotalItem,
    "ApiNft": ApiNft,
    "ApiNftLinkData": ApiNftLinkData,
    "ApiNftLinkMediaPreview": ApiNftLinkMediaPreview,
    "ApiNftLinkResponse": ApiNftLinkResponse,
    "ApiNftMedia": ApiNftMedia,
    "ApiNftOwner": ApiNftOwner,
    "ApiNftOwnerPage": ApiNftOwnerPage,
    "ApiNftsPage": ApiNftsPage,
    "ApiNonceResponse": ApiNonceResponse,
    "ApiNotification": ApiNotification,
    "ApiNotificationsResponse": ApiNotificationsResponse,
    "ApiOutgoingIdentitySubscriptionsPage": ApiOutgoingIdentitySubscriptionsPage,
    "ApiOwnerBalance": ApiOwnerBalance,
    "ApiOwnerBalanceMemes": ApiOwnerBalanceMemes,
    "ApiOwnerBalancePage": ApiOwnerBalancePage,
    "ApiPageBase": ApiPageBase,
    "ApiPageWithNextUriBase": ApiPageWithNextUriBase,
    "ApiPageWithoutCount": ApiPageWithoutCount,
    "ApiProfileMin": ApiProfileMin,
    "ApiProfileMinsPage": ApiProfileMinsPage,
    "ApiProfileProxy": ApiProfileProxy,
    "ApiProfileProxyAction": ApiProfileProxyAction,
    "ApiProfileRepCategorySummary": ApiProfileRepCategorySummary,
    "ApiPushNotificationDevice": ApiPushNotificationDevice,
    "ApiPushNotificationSettings": ApiPushNotificationSettings,
    "ApiPushNotificationSettingsUpdate": ApiPushNotificationSettingsUpdate,
    "ApiQuotedDrop": ApiQuotedDrop,
    "ApiQuotedDropResponse": ApiQuotedDropResponse,
    "ApiRatingWithProfileInfoAndLevel": ApiRatingWithProfileInfoAndLevel,
    "ApiRatingWithProfileInfoAndLevelPage": ApiRatingWithProfileInfoAndLevelPage,
    "ApiRedeemRefreshTokenRequest": ApiRedeemRefreshTokenRequest,
    "ApiRedeemRefreshTokenResponse": ApiRedeemRefreshTokenResponse,
    "ApiRegisterPushNotificationTokenRequest": ApiRegisterPushNotificationTokenRequest,
    "ApiRepCategoriesPage": ApiRepCategoriesPage,
    "ApiRepCategory": ApiRepCategory,
    "ApiRepContributor": ApiRepContributor,
    "ApiRepContributorsPage": ApiRepContributorsPage,
    "ApiRepOverview": ApiRepOverview,
    "ApiRepRating": ApiRepRating,
    "ApiReplyToDrop": ApiReplyToDrop,
    "ApiReplyToDropResponse": ApiReplyToDropResponse,
    "ApiSeizeSettings": ApiSeizeSettings,
    "ApiSetPinnedDropRequest": ApiSetPinnedDropRequest,
    "ApiStartMultipartMediaUploadResponse": ApiStartMultipartMediaUploadResponse,
    "ApiTargetAndSubscriptionActions": ApiTargetAndSubscriptionActions,
    "ApiTdhEdition": ApiTdhEdition,
    "ApiTdhEditionsPage": ApiTdhEditionsPage,
    "ApiTokenTdh": ApiTokenTdh,
    "ApiTokenTdhRank": ApiTokenTdhRank,
    "ApiTransaction": ApiTransaction,
    "ApiTransactionPage": ApiTransactionPage,
    "ApiUndiscoveredDrop": ApiUndiscoveredDrop,
    "ApiUpcomingMemeSubscriptionStatus": ApiUpcomingMemeSubscriptionStatus,
    "ApiUpdateDropRequest": ApiUpdateDropRequest,
    "ApiUpdateProxyActionRequest": ApiUpdateProxyActionRequest,
    "ApiUpdateWaveDecisionPause": ApiUpdateWaveDecisionPause,
    "ApiUpdateWaveParticipationConfig": ApiUpdateWaveParticipationConfig,
    "ApiUpdateWaveRequest": ApiUpdateWaveRequest,
    "ApiUploadItem": ApiUploadItem,
    "ApiUploadPartOfMultipartUploadRequest": ApiUploadPartOfMultipartUploadRequest,
    "ApiUploadPartOfMultipartUploadResponse": ApiUploadPartOfMultipartUploadResponse,
    "ApiUploadsPage": ApiUploadsPage,
    "ApiWallet": ApiWallet,
    "ApiWave": ApiWave,
    "ApiWaveChatConfig": ApiWaveChatConfig,
    "ApiWaveConfig": ApiWaveConfig,
    "ApiWaveContributorOverview": ApiWaveContributorOverview,
    "ApiWaveCurationGroup": ApiWaveCurationGroup,
    "ApiWaveCurationGroupRequest": ApiWaveCurationGroupRequest,
    "ApiWaveDecision": ApiWaveDecision,
    "ApiWaveDecisionAward": ApiWaveDecisionAward,
    "ApiWaveDecisionPause": ApiWaveDecisionPause,
    "ApiWaveDecisionWinner": ApiWaveDecisionWinner,
    "ApiWaveDecisionsPage": ApiWaveDecisionsPage,
    "ApiWaveDecisionsStrategy": ApiWaveDecisionsStrategy,
    "ApiWaveDropsFeed": ApiWaveDropsFeed,
    "ApiWaveLog": ApiWaveLog,
    "ApiWaveMetrics": ApiWaveMetrics,
    "ApiWaveMin": ApiWaveMin,
    "ApiWaveOutcome": ApiWaveOutcome,
    "ApiWaveOutcomeDistributionItem": ApiWaveOutcomeDistributionItem,
    "ApiWaveOutcomeDistributionItemsPage": ApiWaveOutcomeDistributionItemsPage,
    "ApiWaveOutcomesPage": ApiWaveOutcomesPage,
    "ApiWaveParticipationConfig": ApiWaveParticipationConfig,
    "ApiWaveParticipationSubmissionStrategy": ApiWaveParticipationSubmissionStrategy,
    "ApiWaveParticipationSubmissionStrategyIdentityConf": ApiWaveParticipationSubmissionStrategyIdentityConf,
    "ApiWaveRequiredMetadata": ApiWaveRequiredMetadata,
    "ApiWaveScope": ApiWaveScope,
    "ApiWaveSelection": ApiWaveSelection,
    "ApiWaveSelectionDropRequest": ApiWaveSelectionDropRequest,
    "ApiWaveSelectionRequest": ApiWaveSelectionRequest,
    "ApiWaveSubscriptionActions": ApiWaveSubscriptionActions,
    "ApiWaveVisibilityConfig": ApiWaveVisibilityConfig,
    "ApiWaveVoter": ApiWaveVoter,
    "ApiWaveVotersPage": ApiWaveVotersPage,
    "ApiWaveVotingConfig": ApiWaveVotingConfig,
    "ApiXTdhCollection": ApiXTdhCollection,
    "ApiXTdhCollectionsPage": ApiXTdhCollectionsPage,
    "ApiXTdhContribution": ApiXTdhContribution,
    "ApiXTdhContributionsPage": ApiXTdhContributionsPage,
    "ApiXTdhCreateGrant": ApiXTdhCreateGrant,
    "ApiXTdhGlobalStats": ApiXTdhGlobalStats,
    "ApiXTdhGrant": ApiXTdhGrant,
    "ApiXTdhGrantToken": ApiXTdhGrantToken,
    "ApiXTdhGrantTokensPage": ApiXTdhGrantTokensPage,
    "ApiXTdhGrantUpdateRequest": ApiXTdhGrantUpdateRequest,
    "ApiXTdhGrantee": ApiXTdhGrantee,
    "ApiXTdhGranteesPage": ApiXTdhGranteesPage,
    "ApiXTdhGrantsPage": ApiXTdhGrantsPage,
    "ApiXTdhStats": ApiXTdhStats,
    "ApiXTdhToken": ApiXTdhToken,
    "ApiXTdhTokensPage": ApiXTdhTokensPage,
    "CreateDirectMessageWaveRequest": CreateDirectMessageWaveRequest,
    "DistributionNormalized": DistributionNormalized,
    "DistributionNormalizedPage": DistributionNormalizedPage,
    "DistributionOverview": DistributionOverview,
    "DistributionPhasesPage": DistributionPhasesPage,
    "DistributionPhoto": DistributionPhoto,
    "DistributionPhotoCompleteRequest": DistributionPhotoCompleteRequest,
    "DistributionPhotoCompleteRequestPhoto": DistributionPhotoCompleteRequestPhoto,
    "DistributionPhotoCompleteResponse": DistributionPhotoCompleteResponse,
    "DistributionPhotosPage": DistributionPhotosPage,
    "GetWaveSubscription200Response": GetWaveSubscription200Response,
    "MintingClaim": MintingClaim,
    "MintingClaimAnimationDetails": MintingClaimAnimationDetailsClass,
    "MintingClaimAnimationDetailsGlb": MintingClaimAnimationDetailsGlb,
    "MintingClaimAnimationDetailsHtml": MintingClaimAnimationDetailsHtml,
    "MintingClaimAnimationDetailsVideo": MintingClaimAnimationDetailsVideo,
    "MintingClaimAttribute": MintingClaimAttribute,
    "MintingClaimAttributeValue": MintingClaimAttributeValueClass,
    "MintingClaimImageDetails": MintingClaimImageDetails,
    "MintingClaimUpdateRequest": MintingClaimUpdateRequest,
    "MintingClaimsPageResponse": MintingClaimsPageResponse,
    "MintingClaimsProofItem": MintingClaimsProofItem,
    "MintingClaimsProofsResponse": MintingClaimsProofsResponse,
    "MintingClaimsResponse": MintingClaimsResponse,
    "MintingClaimsRootItem": MintingClaimsRootItem,
    "NFTFinalSubscription": NFTFinalSubscription,
    "NFTFinalSubscriptionUpload": NFTFinalSubscriptionUpload,
    "NFTFinalSubscriptionUploadPage": NFTFinalSubscriptionUploadPage,
    "NFTSubscription": NFTSubscription,
    "PhaseAirdrop": PhaseAirdrop,
    "RedeemedSubscription": RedeemedSubscription,
    "RedeemedSubscriptionCounts": RedeemedSubscriptionCounts,
    "RedeemedSubscriptionCountsPage": RedeemedSubscriptionCountsPage,
    "RedeemedSubscriptionPage": RedeemedSubscriptionPage,
    "SubscribeAllEditionsResponse": SubscribeAllEditionsResponse,
    "SubscriptionCountResponse": SubscriptionCountResponse,
    "SubscriptionCounts": SubscriptionCounts,
    "SubscriptionDetails": SubscriptionDetails,
    "SubscriptionLog": SubscriptionLog,
    "SubscriptionLogPage": SubscriptionLogPage,
    "SubscriptionModeResponse": SubscriptionModeResponse,
    "SubscriptionResponse": SubscriptionResponse,
    "SubscriptionTopUp": SubscriptionTopUp,
    "SubscriptionTopUpPage": SubscriptionTopUpPage,
    "UpdateSubscribeAllEditionsRequest": UpdateSubscribeAllEditionsRequest,
    "UpdateSubscriptionCountRequest": UpdateSubscriptionCountRequest,
    "UpdateSubscriptionModeRequest": UpdateSubscriptionModeRequest,
    "UpdateSubscriptionRequest": UpdateSubscriptionRequest,
}

type MimeTypeDescriptor = {
    type: string;
    subtype: string;
    subtypeTokens: string[];
};

/**
 * Every mime-type consists of a type, subtype, and optional parameters.
 * The subtype can be composite, including information about the content format.
 * For example: `application/json-patch+json`, `application/merge-patch+json`.
 *
 * This helper transforms a string mime-type into an internal representation.
 * This simplifies the implementation of predicates that in turn define common rules for parsing or stringifying
 * the payload.
 */
const parseMimeType = (mimeType: string): MimeTypeDescriptor => {
    const [type = '', subtype = ''] = mimeType.split('/');
    return {
        type,
        subtype,
        subtypeTokens: subtype.split('+'),
    };
};

type MimeTypePredicate = (mimeType: string) => boolean;

// This factory creates a predicate function that checks a string mime-type against defined rules.
const mimeTypePredicateFactory = (predicate: (descriptor: MimeTypeDescriptor) => boolean): MimeTypePredicate => (mimeType) => predicate(parseMimeType(mimeType));

// Use this factory when you need to define a simple predicate based only on type and, if applicable, subtype.
const mimeTypeSimplePredicateFactory = (type: string, subtype?: string): MimeTypePredicate => mimeTypePredicateFactory((descriptor) => {
    if (descriptor.type !== type) return false;
    if (subtype != null && descriptor.subtype !== subtype) return false;
    return true;
});

// Creating a set of named predicates that will help us determine how to handle different mime-types
const isTextLikeMimeType = mimeTypeSimplePredicateFactory('text');
const isJsonMimeType = mimeTypeSimplePredicateFactory('application', 'json');
const isJsonLikeMimeType = mimeTypePredicateFactory((descriptor) => descriptor.type === 'application' && descriptor.subtypeTokens.some((item) => item === 'json'));
const isOctetStreamMimeType = mimeTypeSimplePredicateFactory('application', 'octet-stream');
const isFormUrlencodedMimeType = mimeTypeSimplePredicateFactory('application', 'x-www-form-urlencoded');

// Defining a list of mime-types in the order of prioritization for handling.
const supportedMimeTypePredicatesWithPriority: MimeTypePredicate[] = [
    isJsonMimeType,
    isJsonLikeMimeType,
    isTextLikeMimeType,
    isOctetStreamMimeType,
    isFormUrlencodedMimeType,
];

const nullableSuffix = " | null";
const optionalSuffix = " | undefined";
const arrayPrefix = "Array<";
const arraySuffix = ">";
const mapPrefix = "{ [key: string]: ";
const mapSuffix = "; }";

export class ObjectSerializer {
    public static findCorrectType(data: any, expectedType: string) {
        if (data == undefined) {
            return expectedType;
        } else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
            return expectedType;
        } else if (expectedType === "Date") {
            return expectedType;
        } else {
            if (enumsMap.has(expectedType)) {
                return expectedType;
            }

            if (!typeMap[expectedType]) {
                return expectedType; // w/e we don't know the type
            }

            // Check the discriminator
            let discriminatorProperty = typeMap[expectedType].discriminator;
            if (discriminatorProperty == null) {
                return expectedType; // the type does not have a discriminator. use it.
            } else {
                if (data[discriminatorProperty]) {
                    var discriminatorType = data[discriminatorProperty];
                    let mapping = typeMap[expectedType].mapping;
                    if (mapping != undefined && mapping[discriminatorType]) {
                        return mapping[discriminatorType]; // use the type given in the discriminator
                    } else if(typeMap[discriminatorType]) {
                        return discriminatorType;
                    } else {
                        return expectedType; // discriminator did not map to a type
                    }
                } else {
                    return expectedType; // discriminator was not present (or an empty string)
                }
            }
        }
    }

    public static serialize(data: any, type: string, format: string): any {
        if (data == undefined) {
            return data;
        } else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        } else if (type.endsWith(nullableSuffix)) {
            let subType: string = type.slice(0, -nullableSuffix.length); // Type | null => Type
            return ObjectSerializer.serialize(data, subType, format);
        } else if (type.endsWith(optionalSuffix)) {
            let subType: string = type.slice(0, -optionalSuffix.length); // Type | undefined => Type
            return ObjectSerializer.serialize(data, subType, format);
        } else if (type.startsWith(arrayPrefix)) {
            let subType: string = type.slice(arrayPrefix.length, -arraySuffix.length); // Array<Type> => Type
            let transformedData: any[] = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.serialize(date, subType, format));
            }
            return transformedData;
        } else if (type.startsWith(mapPrefix)) {
            let subType: string = type.slice(mapPrefix.length, -mapSuffix.length); // { [key: string]: Type; } => Type
            let transformedData: { [key: string]: any } = {};
            for (let key in data) {
                transformedData[key] = ObjectSerializer.serialize(
                    data[key],
                    subType,
                    format,
                );
            }
            return transformedData;
        } else if (type === "Date") {
            if (format == "date") {
                let month = data.getMonth()+1
                month = month < 10 ? "0" + month.toString() : month.toString()
                let day = data.getDate();
                day = day < 10 ? "0" + day.toString() : day.toString();

                return data.getFullYear() + "-" + month + "-" + day;
            } else {
                return data.toISOString();
            }
        } else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) { // in case we dont know the type
                return data;
            }

            // Get the actual type of this object
            type = this.findCorrectType(data, type);

            // get the map for the correct type.
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            let instance: {[index: string]: any} = {};
            for (let attributeType of attributeTypes) {
                instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type, attributeType.format);
            }
            return instance;
        }
    }

    public static deserialize(data: any, type: string, format: string): any {
        // polymorphism may change the actual type.
        type = ObjectSerializer.findCorrectType(data, type);
        if (data == undefined) {
            return data;
        } else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        } else if (type.endsWith(nullableSuffix)) {
            let subType: string = type.slice(0, -nullableSuffix.length); // Type | null => Type
            return ObjectSerializer.deserialize(data, subType, format);
        } else if (type.endsWith(optionalSuffix)) {
            let subType: string = type.slice(0, -optionalSuffix.length); // Type | undefined => Type
            return ObjectSerializer.deserialize(data, subType, format);
        } else if (type.startsWith(arrayPrefix)) {
            let subType: string = type.slice(arrayPrefix.length, -arraySuffix.length); // Array<Type> => Type
            let transformedData: any[] = [];
            for (let date of data) {
                transformedData.push(ObjectSerializer.deserialize(date, subType, format));
            }
            return transformedData;
        } else if (type.startsWith(mapPrefix)) {
            let subType: string = type.slice(mapPrefix.length, -mapSuffix.length); // { [key: string]: Type; } => Type
            let transformedData: { [key: string]: any } = {};
            for (let key in data) {
                transformedData[key] = ObjectSerializer.deserialize(
                    data[key],
                    subType,
                    format,
                );
            }
            return transformedData;
        } else if (type === "Date") {
            return new Date(data);
        } else {
            if (enumsMap.has(type)) {// is Enum
                return data;
            }

            if (!typeMap[type]) { // dont know the type
                return data;
            }
            let instance = new typeMap[type]();
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            for (let attributeType of attributeTypes) {
                let value = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type, attributeType.format);
                if (value !== undefined) {
                    instance[attributeType.name] = value;
                }
            }
            return instance;
        }
    }


    /**
     * Normalize media type
     *
     * We currently do not handle any media types attributes, i.e. anything
     * after a semicolon. All content is assumed to be UTF-8 compatible.
     */
    public static normalizeMediaType(mediaType: string | undefined): string | undefined {
        if (mediaType === undefined) {
            return undefined;
        }
        return (mediaType.split(";")[0] ?? '').trim().toLowerCase();
    }

    /**
     * From a list of possible media types, choose the one we can handle best.
     *
     * The order of the given media types does not have any impact on the choice
     * made.
     */
    public static getPreferredMediaType(mediaTypes: Array<string>): string {
        /** According to OAS 3 we should default to json */
        if (mediaTypes.length === 0) {
            return "application/json";
        }

        const normalMediaTypes = mediaTypes.map(this.normalizeMediaType);

        for (const predicate of supportedMimeTypePredicatesWithPriority) {
            for (const mediaType of normalMediaTypes) {
                if (mediaType != null && predicate(mediaType)) {
                    return mediaType;
                }
            }
        }

        throw new Error("None of the given media types are supported: " + mediaTypes.join(", "));
    }

    /**
     * Convert data to a string according the given media type
     */
    public static stringify(data: any, mediaType: string): string {
        if (isTextLikeMimeType(mediaType)) {
            return String(data);
        }

        if (isJsonLikeMimeType(mediaType)) {
            return JSON.stringify(data);
        }

        throw new Error("The mediaType " + mediaType + " is not supported by ObjectSerializer.stringify.");
    }

    /**
     * Parse data from a string according to the given media type
     */
    public static parse(rawData: string, mediaType: string | undefined) {
        if (mediaType === undefined) {
            throw new Error("Cannot parse content. No Content-Type defined.");
        }

        if (isTextLikeMimeType(mediaType)) {
            return rawData;
        }

        if (isJsonLikeMimeType(mediaType)) {
            return JSON.parse(rawData);
        }

        throw new Error("The mediaType " + mediaType + " is not supported by ObjectSerializer.parse.");
    }
}
